module.exports = __webpack_public_path__ + "assets/images/p1_0b3dff0eec1250b978297895d589c0d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packs/p1.png
// module id = 125
// module chunks = 0